import {React,  useState ,useEffect,useRef} from "react";
import { useNavigate  } from "react-router-dom";
import   axios from "axios";
import './passport.css';
import 'bootstrap/dist/css/bootstrap.css';
import KycShell, { BrowserOnlyWarning } from '../components/KycShell';

const ProffAdress = () => {
	const inputRef = useRef(null);
	const brandname = localStorage.getItem('brandname');
	const [isMobile, setIsMobile] = useState(true);
	const navigate = useNavigate();
    const [file, setFile] = useState();
    const [visible, setVisible] = useState(false);
	const [disabledbtn, setdisabled] = useState(false);
	const [selvisible, setSelvisible] = useState(true);

	const [btn , setbtn] = useState("btn btn-primary");
	const [btntxt , setbtntxt] = useState("Continue");
	const [btnicon , setbtnicon] = useState("fa-solid fa-arrow-right");

		let photo = '';
		const [info , setinfo]=useState({
			image : ''
		});

		const partial_page = localStorage.getItem('partial_page');
		const kyctype = localStorage.getItem('kyctype');
		const getData = async () => {
			const res = await axios.get("https://api.ipify.org/?format=json");
			// console.log(res.data);
			localStorage.setItem('Ip-Adrees', res.data.ip);
		};
		//console.log(kyctype);
		const retake= ()=>{
			setinfo({
				id:'proof-address',
				image :photo
			});
			setFile('');
			setSelvisible(true);
			setVisible(false);
			setdisabled(false);

			setbtntxt("Continue");
			setbtn("btn btn-primary");
			setbtnicon("fa-solid fa-arrow-right");
		}
		const nextpage= ()=>{
			setbtntxt("Uploading");
			setbtn("btn btn-success");
			setbtnicon("fa-solid fa-check");
			setdisabled(true);
			setTimeout(function(){ setdisabled(false); },10000);
			saveinternal();
		}
		const clicktoselect = ()=>{
			inputRef.current.click()
		}
		const saveinternal = async () => {

			let datas = JSON.stringify({
			  "uuid": localStorage.getItem('uuid'),
			  "image": info.image,
			  "type": 'address',
			});
			console.log(datas);
			let config = {
				  method: 'post',
				 'mode':'cors',
				  url: 'https://kyc2.codegotech.com/save_image',
				  headers: {
					'Content-Type': 'application/json'
				  },
				  data : datas
			};

			axios.request(config).then((response) => {
			if(response.status===200)
			{
				//console.log(response);

				if(response.data.status === 1)
				{
					if(kyctype === 'partial' && partial_page === 'ADDRESS')
					{

						let data = JSON.stringify({
							"uuid":localStorage.getItem('uuid'),
							"kyctype": kyctype,
							"partial_page": partial_page,
							"userAgent": localStorage.getItem('userAgent'),
							"ip_address": localStorage.getItem('Ip-Adrees'),
							"proofphoto": response.data.image
						});
						let config = {
							  method: 'post',
							 'mode':'cors',
							  url: 'https://kyc2.codegotech.com/send_userdata',
							  headers: {
								'Content-Type': 'application/json'
							  },
							  data : data
						};
						axios.request(config).then((response) => {
							//console.log(response.status);
							if(response.status === 200)
							{
								localStorage.removeItem('userAgent');
								localStorage.removeItem('Ip-Adrees');
								localStorage.removeItem('proofPhoto');
								localStorage.removeItem('uuid');
								navigate('/process');
							}
						}).catch((error) => {
							console.log(error);
						});
					}else{
						localStorage.setItem('proofPhoto', response.data.image);
						navigate('/Recognition')
					}
				}else{
					setVisible(false);
					let html = 'Please re-upload proof address.';
					let mrz_data_element = document.getElementById('mrz-data')
					mrz_data_element.innerHTML =  html
				}
			}
			})
			.catch((error) => {
			  console.log(error);
			});
		}

    useEffect(() => {
		let uuids = localStorage.getItem('uuid');
		if(uuids === null)
		{
			navigate('/');
		}
		getData();
    }, [])
	return (
	<>
        {!isMobile && <BrowserOnlyWarning />}

        {isMobile && (
			<KycShell step={2} brandName={brandname}>
				<div className="kyc-card">
					<div className="kyc-card__eyebrow">Proof of address</div>
					<h1 className="kyc-card__title">Upload a proof of address</h1>
					<p className="kyc-card__subtitle">
						Make sure all information on the document is visible and easy to read.
					</p>

					<div id='mrz-data' style={{ color: 'var(--kyc-danger)', fontSize: 13, fontWeight: 500 }} />

					{selvisible && (
						<div className="kyc-dropzone" onClick={clicktoselect} role="button" tabIndex={0}>
							<div className="kyc-dropzone__icon">
								<i className="fa fa-cloud-upload" aria-hidden="true"></i>
							</div>
							<p className="kyc-dropzone__title">Select a file to upload</p>
							<p className="kyc-dropzone__hint">
								PDF, JPG or PNG. Max 10 MB.
							</p>
							<button type="button" className="kyc-btn kyc-btn-primary btn btn-primary mt-3 mb-3" onClick={(e) => { e.stopPropagation(); clicktoselect(); }} style={{ maxWidth: 220, marginTop: 8 }}>
								<i className="fa-solid fa-id-card" style={{ marginRight: 8 }}></i> Choose file
							</button>
						</div>
					)}

					<input
						type="file"
						id="photo"
						accept="image/*,application/pdf"
						style={{ display: 'none' }}
						ref={inputRef}
						className="custom-file-input"
						onChange={(evt) => {
							try {
								const mrz = document.getElementById('mrz-data');
								if (mrz) mrz.innerHTML = '';
								if (!evt.target.files || !evt.target.files.length) return;
								const myFile = evt.target.files[0];
								if (myFile.size > 10 * 1024 * 1024) {
									if (mrz) mrz.innerHTML = 'File too large (max 10 MB).';
									evt.target.value = '';
									return;
								}
								const reader = new FileReader();
								reader.onload = function (e) {
									photo = e.target.result;
									setinfo({ image: photo });
								};
								reader.onerror = function () {
									if (mrz) mrz.innerHTML = 'Could not read the file. Please try again.';
								};
								reader.readAsDataURL(myFile);
								setFile('File: ' + myFile.name);
								setSelvisible(false);
								setVisible(true);
							} catch (err) {
								console.error('proofAddress onChange error:', err);
								const mrz = document.getElementById('mrz-data');
								if (mrz) mrz.innerHTML = 'Unexpected error reading the file. Please try again.';
							}
						}}
					/>

					{file && (
						<div className="kyc-file-chip">
							<span className="kyc-file-chip__icon">
								<i className="fa fa-file" aria-hidden="true"></i>
							</span>
							<span>{file}</span>
						</div>
					)}

					{file && (
						<div className="kyc-capture-actions d-flex flex-column flex-sm-row gap-2">
							<button disabled={disabledbtn} className="kyc-btn kyc-btn-secondary btn btn-outline-secondary w-100" onClick={retake}>
								<i className="fa-solid fa-repeat" style={{ marginRight: 8 }}></i> Retake
							</button>
							<button className={btn + ' kyc-btn kyc-btn-primary w-100'}  disabled={disabledbtn} onClick={nextpage}>
								{btntxt} <i className={btnicon} style={{ marginLeft: 8 }}></i>
							</button>
						</div>
					)}

					{/* Fallback submit if primary block didn't render but a file was selected */}
					{!file && !selvisible && (
						<div className="kyc-capture-actions d-flex flex-column flex-sm-row gap-2" style={{ marginTop: 14 }}>
							<button className="kyc-btn kyc-btn-secondary btn btn-outline-secondary w-100" onClick={() => { setSelvisible(true); }}>
								<i className="fa-solid fa-repeat" style={{ marginRight: 8 }}></i> Choose another file
							</button>
						</div>
					)}
				</div>

				<div className="kyc-card">
					<div className="kyc-card__eyebrow">Accepted documents</div>
					<ul className="kyc-info-list list_proof">
						<li>Utility bill (less than 3 months)</li>
						<li>Bank account statement (less than 3 months)</li>
						<li>Certificate of residence (released by the municipality)</li>
					</ul>
				</div>
			</KycShell>
        )}
	</>
	);
}
export default ProffAdress;
